import { useState, useEffect } from 'react';

function getMediaStreamTrack(track: any): MediaStreamTrack | undefined {
  if (!track) return undefined;
  if (typeof track.getMediaStreamTrack === 'function') return track.getMediaStreamTrack();
  return track.mediaStreamTrack;
}

export default function useMediaStreamTrack(track: any) {
  const [mediaStreamTrack, setMediaStreamTrack] = useState(getMediaStreamTrack(track));

  useEffect(() => {
    setMediaStreamTrack(getMediaStreamTrack(track));
  }, [track]);

  return mediaStreamTrack;
}
